// import Api from "../../utils/config/api";
// import { toastr } from "react-redux-toastr";
import { toastr } from "react-redux-toastr";
import Api from "../../utils/config/api";
import {
  SET_TEMP_AUTO_CAMPAIGN,
  SET_AUTO_CAMPAIGN_TEMPLATE,
  SET_AUTO_CAMPAIGN_TEMPLATES,
  SET_AUTO_DRAFTED_CAMP_STATE,
  SET_AUTO_CAMP_SHORTLINK,
  RESET_AUTO_DRAFTED_CAMP_STATE,
  SET_AUTO_CAMP_DETAIL,
  SET_AUTO_CAMPAIGNS_CUSTOMERS_LIST,
  SET_AUTO_CAMPAIGN_OVERVIEW,
  RESET_AUTO_CAMPS,
  SET_ACTIVE_AUTO_CAMP_IDS,
  SET_AUTO_CAMPAIGN_DRAFTS,
  INIT_AUTO_DRAFTED_CAMP_STATE,
} from "../types";

export const setCurrAutoCamp = (data) => (dispatch) => {
  dispatch({
    payload: data,
    type: SET_AUTO_CAMPAIGN_TEMPLATE,
  });
};

export const setShortlink = (link) => (dispatch) => {
  dispatch({
    type: SET_AUTO_CAMP_SHORTLINK,
    payload: link,
  });
};

export const setTempCampState = (data) => (dispatch) => {
  dispatch({
    payload: data,
    type: SET_TEMP_AUTO_CAMPAIGN,
  });
};

export const setDraftAutoCampaigns = (data) => (dispatch) => {
  dispatch({
    payload: data,
    type: SET_AUTO_DRAFTED_CAMP_STATE,
  });
};

export const resetDraftAutoCampaigns = () => (dispatch) => {
  dispatch({
    payload: {},
    type: RESET_AUTO_DRAFTED_CAMP_STATE,
  });
};

export const initalizeAutoCampState = () => (dispatch) => {
  dispatch({
    type: RESET_AUTO_CAMPS,
  });
};

export const resetAutoCampState = () => (dispatch) => {
  dispatch(setShortlink(""));
  dispatch(setCurrAutoCamp({}));
  dispatch(resetDraftAutoCampaigns());
};

export const getAutoCampaignTemplatesCall =
  (store_id, queries) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.get(
        `/v2/campaigns/templates/${store_id}?auto_campaign=true&page=${
          queries?.page || 1
        }&limit=${queries?.limit || 50}${
          queries?.type ? `&type=${queries?.type}` : ""
        }${queries?.objective ? `&objective=${queries?.objective}` : ""}${
          queries?.is_whatsapp_enable
            ? `&is_whatsapp_enable=${queries?.is_whatsapp_enable}`
            : ""
        }`
      )
        .then((res) => {
          dispatch({
            type: SET_AUTO_CAMPAIGN_TEMPLATES,
            payload: res?.data?.payload,
          });

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  };

export const setDraftAutoCampFrmHome = (camp) => (dispatch) => {
  dispatch({
    type: INIT_AUTO_DRAFTED_CAMP_STATE,
    payload: camp,
  });
};

export const getDraftAutoCampaigns = (entityId, queries) => (dispatch) => {
  const data = queries.data;
  const page = queries.page;
  const limit = queries.limit;

  return new Promise((resolve, reject) => {
    Api.post(
      `/v1/campaigns/store/${entityId}?${
        limit ? `limit=${limit}` : "&limit=5"
      }${page ? `&page=${page}` : "&page=1"}`,
      data
    )
      .then((res) => {
        dispatch({
          type: SET_AUTO_CAMPAIGN_DRAFTS,
          payload: res?.data?.payload,
        });
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        toastr.error(
          err?.response?.data?.message || "Error fetching Draft campaigns"
        );
        return reject(err);
      });
  });
};

export const deleteDraftAutoCampaigns = (storeId, campId) => () => {
  return new Promise((resolve, reject) => {
    Api.delete(`/v1/campaigns/${campId}/store/${storeId}`)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Failed to delete the draft."
        );
        return reject(err);
      });
  });
};

export const initializeAutoCampaign = (storeId, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/campaigns/${storeId}`, data)
      .then((res) => {
        dispatch(setDraftAutoCampaigns(res?.data?.payload));

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const setAutoCampImgCall =
  (storeID, campID, data, isCache) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.patch(
        `/v1/campaigns/${campID}/banner/${storeID}${
          isCache ? "?cache=true" : ""
        }`,
        data
      )
        .then((res) => {
          dispatch(setDraftAutoCampaigns(res?.data?.payload));

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err);
        });
    });
  };

export const setAutoRewardsCall =
  (storeId, campID, data, isCache) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.patch(
        `/v1/campaigns/${campID}/reward/${storeId}${
          isCache ? "?cache=true" : ""
        }`,
        data
      )
        .then((res) => {
          dispatch(setDraftAutoCampaigns(res?.data?.payload));

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err);
        });
    });
  };

export const setAutoTermsCall =
  (storeID, campID, data, isCache) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.patch(
        `/v1/campaigns/${campID}/terms/${storeID}${
          isCache ? "?cache=true" : ""
        }`,
        data
      )
        .then((res) => {
          dispatch(setDraftAutoCampaigns(res?.data?.payload));

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err);
        });
    });
  };

export const setAutoCampMsgCall =
  (channel, storeID, campID, data, isCache) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.patch(
        `/v1/campaigns/${campID}/${channel}/message/${storeID}${
          isCache ? "?cache=true" : ""
        }`,
        data
      )
        .then((res) => {
          dispatch(setDraftAutoCampaigns(res?.data?.payload));

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );

          return reject(err);
        });
    });
  };

export const setAutoCampReminderMsgCall =
  (channel, storeID, campID, data, isCache) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.patch(
        `/v1/campaigns/${campID}/${channel}/reminder-message/${storeID}${
          isCache ? "?cache=true" : ""
        }`,
        data
      )
        .then((res) => {
          dispatch(setDraftAutoCampaigns(res?.data?.payload));

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );

          return reject(err);
        });
    });
  };

export const setAutoEmailSubjectCall =
  (storeID, campID, data, reminder, isCache) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.patch(
        `/v1/campaigns/${campID}/email/subject/${storeID}${
          reminder ? "?reminder=true" : ""
        }${isCache ? `${reminder ? "&" : "?"}cache=true` : ""}`,
        data
      )
        .then((res) => {
          dispatch(setDraftAutoCampaigns(res?.data?.payload));

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );

          return reject(err);
        });
    });
  };

export const autoCampInstantApprovalTemplate =
  (channel, entityId, campID, isReminderActive) => () => {
    return new Promise((resolve, reject) => {
      Api.patch(
        `v1/campaigns/${campID}/${channel}/custom/template/${entityId}/submit${
          isReminderActive ? "?reminder=true" : ""
        }`,
        {}
      )
        .then((res) => {
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          return reject(err.response.data.message);
        });
    });
  };

export const getAutoShortLinkCall = (storeID, campID) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/campaigns/${campID}/shortlink/${storeID}`)
      .then((res) => {
        dispatch(setShortlink(res?.data?.payload?.link));
        return resolve(res?.data?.payload?.link);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const setAutoChannelCall =
  (storeID, campID, data, isCache) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.patch(
        `/v1/campaigns/${campID}/channels/${storeID}${
          isCache ? "?cache=true" : ""
        }`,
        data
      )
        .then((res) => {
          dispatch(setDraftAutoCampaigns(res?.data?.payload));

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err);
        });
    });
  };

export const setAutoCampTime = (storeID, campId, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.patch(`/v1/campaigns/${campId}/schedule/${storeID}`, data)
      .then((res) => {
        if (!data?.cancelled) {
          dispatch(setDraftAutoCampaigns(res?.data?.payload));
        }
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const clearCachedAutoCampData = (campId, entityId) => {
  return new Promise((resolve, reject) => {
    Api.delete(`/v1/campaigns/${campId}/store/${entityId}?cache=true`)
      .then((res) => resolve(res.data.payload))
      .catch((err) => reject(err?.response?.data?.message));
  });
};

const getCampTitle = (titleObj) => {
  return titleObj?.content?.replace(
    /{{(.+?)}}/g,
    (_, g1) => titleObj?.variables[g1] || g1
  );
};

export const getAutoCampById = (campId, entityId, cache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/campaigns/${campId}/store/${entityId}${cache ? "?cache=true" : ""}`
    )
      .then((res) => {
        let camp = res?.data?.payload;
        dispatch(
          setCurrAutoCamp({
            index: 0,
            label: `${
              camp?.template_details?.objective?.value
            } - ${getCampTitle(camp?.template_details?.template?.title)}`,
            value: {
              ...camp?.template_details?.template,
              unique_id: camp?.template_details?.unique_id,
              label: camp?.template_details?.objective?.value,
              category: camp?.template_details?.objective?.key,
            },
          })
        );
        let duplicateCamp = { ...camp };
        duplicateCamp.id = duplicateCamp?._id;
        delete duplicateCamp?._id;
        if (!cache) delete duplicateCamp?.template_details;

        dispatch(setDraftAutoCampaigns(duplicateCamp));
        return resolve(duplicateCamp);
      })
      .catch((err) => {
        toastr.error(
          err?.response?.data?.message || "Error fetching Campaign Preview"
        );
        return reject(err);
      });
  });
};

// insights

export const getAutoCampPerfOverview =
  (storeID, period, start, end) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.get(
        `/v1/insights/campaign/performance/${storeID}?auto_campaign=true${
          period &&
          `&period=${period}${start ? `&start=${start}` : ""}${
            end ? `&end=${end}` : ""
          }`
        }`
      )
        .then((res) => {
          dispatch({
            type: SET_AUTO_CAMPAIGN_OVERVIEW,
            payload: res?.data?.payload,
          });
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          toastr.error(
            err?.response?.data?.message ||
              "Error fetching Campaigns Performance"
          );
          return reject(err);
        });
    });
  };

export const getAutoCampListing = (query) => {
  const entityId = query?.entityId,
    page = query?.page || 1,
    status = query?.status || "",
    objective = query?.objective || "",
    limit = query?.limit || 10,
    period = query?.period || "",
    start = query?.start || "",
    end = query?.end || "";

  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/insights/campaigns/${entityId}?${page ? `page=${page}` : "page=1"}${
        period ? `&period=${period}` : ""
      }${status ? `&status=${status}` : ""}${
        objective ? `&objective=${objective}` : ""
      }${limit ? `&limit=${limit}` : ""}${start && `&start=${start}`}${
        end && `&end=${end}`
      }&auto_campaign=true`
    )
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        toastr.error(
          err?.response?.data?.message || "Error fetching Campaigns Listings"
        );
        return reject(err);
      });
  });
};

export const getAutoCampDetail =
  (storeID, campId, start, end) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.get(
        `/v1/insights/${campId}/overview/${storeID}?period=custom&start=${start}&end=${end}`
      )
        .then((res) => {
          dispatch({
            type: SET_AUTO_CAMP_DETAIL,
            payload: res?.data?.payload,
          });
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          toastr.error(
            err?.response?.data?.message || "Error fetching Campaigns Detail"
          );
          return reject(err);
        });
    });
  };

export const getAutoCampCustomerList =
  (
    data,
    storeID,
    campId,
    limit,
    page,
    search,
    period,
    start,
    end,
    isAttachment
  ) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.post(
        `/v1/insights/${campId}/audience/activity/${storeID}?${
          limit ? `limit=${limit}` : "limit=20"
        }${page ? `&page=${page}` : "&page=1"}${
          search ? `&search=${search}` : ""
        }&period=${period}&start=${start}&end=${end}${
          isAttachment ? "&attachment=true" : ""
        }`,
        data
      )
        .then((res) => {
          if (!isAttachment)
            dispatch({
              type: SET_AUTO_CAMPAIGNS_CUSTOMERS_LIST,
              payload: res?.data?.payload,
            });
          return resolve(isAttachment ? res?.data : res?.data?.payload);
        })
        .catch((err) => {
          toastr.error(
            err?.response?.data?.message || "Error fetching Draft campaigns"
          );
          return reject(err);
        });
    });
  };

export const setActiveCampaignIds = (data) => (dispatch) => {
  dispatch({
    type: SET_ACTIVE_AUTO_CAMP_IDS,
    payload: data,
  });
};
